import axios from 'axios'
import qs from 'qs'

export default {
  state: {
    pollInfo: null,
    answers: [],
    sendInfo: null,
    pollId: null,
    errorFromServer: ''
  },
  getters: {
    unselectedQuestionsId (state) {
      if (!state.pollInfo) return
      const uids = []

      state.pollInfo.poll.pollQuestions.forEach(question => {
        let shouldBePushed = question.type !== 'textarea'

        for (let i = 0; i < state.answers.length; i++) {
          if (question.uid === state.answers[i].question_uid) {
            shouldBePushed = false
          }
        }

        if (shouldBePushed) uids.push(question.uid)
      })

      return uids
    }
  },
  mutations: {
    SET_POLL_INFO (state, info) {
      info.forEach(item => {
        if (!(item && item.poll)) {
          state.pollInfo = undefined
          return
        }

        item.poll.pollQuestions = item.poll.pollQuestions.sort((a, b) => {
          return Number(a.sort) - Number(b.sort)
        })

        state.pollInfo = item
      })
    },
    SET_ANSWERS (state, answer) {
      const clone = state.answers.slice()
      let currentAnswerIndex = null

      clone.forEach((el, i) => {
        if (el.question_uid === answer.question_uid) {
          currentAnswerIndex = i
        }
      })

      if (currentAnswerIndex !== null) {
        if (!answer.answer || !answer.answer.length) {
          clone.splice(currentAnswerIndex, 1)
        } else {
          clone[currentAnswerIndex] = answer
        }
      } else {
        clone.push(answer)
      }

      state.answers = clone
    },
    SET_SEND_INFO (state, info) {
      state.sendInfo = info
    },
    SET_POLL_ID (state, id) {
      state.pollId = id
    },
    SET_ERROR_FROM_SERVER (state, error) {
      state.errorFromServer = error
    }
  },
  actions: {
    FETCH_POLL_INFO ({ commit, rootGetters }, pollId) {
      commit('SET_POLL_ID', pollId)
      return new Promise(resolve => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/poll/info/', { params: { id: pollId } })
          .then(response => {
            commit('SET_POLL_INFO', response.data.poll_data)
            resolve(response.data)
          })
      })
    },
    SET_ANSWER ({ commit }, answer) {
      commit('SET_ANSWERS', answer)
    },
    SEND_RESULTS ({ commit, rootGetters, state, dispatch }) {
      const { answers, pollInfo } = state

      const params = {
        answers,
        poll_id: pollInfo.poll_id,
        user_id: pollInfo.user_id,
        survey_uid: pollInfo.poll.uid,
        customer_uid: pollInfo.customer_uid,
        document_uid: pollInfo.document_uid
      }

      axios
        .post(rootGetters.urlLanguagePrefix + '/poll/result/', qs.stringify(params))
        .then(response => {
          commit('SET_SEND_INFO', response.data)
          if (!response.data.success) {
            dispatch('FETCH_POLL_INFO', state.pollId)
              .then(response => {
                if (response.success) {
                  commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred'))
                }
              })
          }
        })
    }
  }
}
